import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { userApi } from '../utils/api';
import toast from 'react-hot-toast';
import { useLanguageStore } from '../stores/languageStore';

const EmailVerify: React.FC = () => {
  const { language } = useLanguageStore();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      const type = searchParams.get('type');

      if (!token || !type) {
        setError(language === 'en' ? 'Verification link is invalid, missing required parameters' : '验证链接无效，缺少必要参数');
        setVerifying(false);
        return;
      }

      try {
        const response = await fetch(`/api/users/verify-email?token=${token}&type=${type}`);
        const data = await response.json();

        if (data.success) {
          setVerified(true);
          if (type === 'reset_password' && data.data?.token) {
            toast.success(language === 'en' ? 'Verification successful, redirecting...' : '验证成功，正在跳转...');
            setTimeout(() => {
              window.location.href = `/reset-password?token=${data.data.token}`;
            }, 1000);
          } else {
            toast.success(language === 'en' ? 'Email verified successfully!' : '邮箱验证成功！');
          }
        } else {
          setError(data.message || (language === 'en' ? 'Email verification failed' : '邮箱验证失败'));
        }
      } catch (error) {
        setError(language === 'en' ? 'Verification failed, please try again later' : '验证失败，请稍后再试');
      } finally {
        setVerifying(false);
      }
    };

    verifyEmail();
  }, [searchParams]);

  if (verifying) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">{language === 'en' ? 'Verifying email...' : '正在验证邮箱...'}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="card p-8 w-full max-w-md text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{language === 'en' ? 'Verification Failed' : '验证失败'}</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <div className="space-y-3">
            <a href="/register" className="btn btn-primary w-full block text-center">
              {language === 'en' ? 'Back to Register' : '返回注册'}
            </a>
            <a href="/login" className="text-blue-600 hover:text-blue-700 text-sm">
              {language === 'en' ? 'Back to Login' : '返回登录'}
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="card p-8 w-full max-w-md text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">{language === 'en' ? 'Email Verified Successfully' : '邮箱验证成功'}</h2>
        <p className="text-gray-600 mb-6">
          {language === 'en' ? 'Congratulations! Your email has been verified successfully. You can now login.' : '恭喜！您的邮箱已验证成功，现在可以登录了。'}
        </p>
        <a href="/login" className="btn btn-primary w-full block text-center">
          {language === 'en' ? 'Go to Login' : '前往登录'}
        </a>
      </div>
    </div>
  );
};

export default EmailVerify;